import { holdBuildRefresh } from './web-build-refresh';

/**
 * In-memory store for the bearer `twoFactorToken` returned by `POST /auth/sign-in`
 * when 2FA is required (mobile/cross-origin clients). The token is the
 * `better-auth.two_factor=…` cookie pair as a raw string; we forward it back to
 * the server via the request body on `POST /auth/two-factor/verify-totp` so the
 * Cookie header survives the cross-origin round-trip.
 *
 * Cleared after a successful verification.
 */
let twoFactorToken: string | undefined;
let releaseBuildHold: (() => void) | undefined;

export function getTwoFactorToken(): string | undefined {
  return twoFactorToken;
}

/**
 * The token lives only in memory and has to survive the sign-in → verify-2fa
 * page change. A full page load there (lib/web-build-refresh.ts handing the
 * navigation to a newer deploy) would drop it and bounce the user back to
 * sign-in, so holding the token holds the build.
 */
export function setTwoFactorToken(token: string | undefined): void {
  twoFactorToken = token;
  releaseBuildHold?.();
  releaseBuildHold = token ? holdBuildRefresh() : undefined;
}

export function clearTwoFactorToken(): void {
  setTwoFactorToken(undefined);
}
